import { SVGProps } from 'react';

const Moon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={17} height={20} viewBox="0 0 17 20" fill="none" {...props}>
    <g filter="url(#aMoon)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M12.25 11.564a6.002 6.002 0 0 1 0-11.128 6 6 0 1 0 0 11.128Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="aMoon"
        width={16.25}
        height={20}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0941176 0 0 0 0 0.0980392 0 0 0 0 0.168627 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8753_35075"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_8753_35075"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default Moon;
